import {Box} from "@mui/material"
import {ReactNode} from "react"

import {useRouterInfo} from "../features/management/api/ManagementHook"
import {Body} from "../shared/component/layout/Body"
import {Footer} from "../shared/component/layout/Footer"
import {Header} from "../shared/component/layout/Header"
import {SxPropsMap} from "../shared/helper/HelperType"
import {useQueryParamErrorHandler} from "../shared/hook/QueryParamErrorHandler"

const SX: SxPropsMap = {
    // NOTE: we need -8px for the bottom scroll, right scroll is always shown that is why we don't need calc
    box: {display: "flex", flexDirection: "column", gap: 2, flexWrap: "nowrap", minHeight: "calc(100vh - 8px)", minWidth: "320px"},
    body: {display: "flex", justifyContent: "center", alignItems: "stretch", flexGrow: 1},
}

type Props = {
    children?: ReactNode,
}

export function App(props: Props) {
    useQueryParamErrorHandler()
    const info = useRouterInfo()
    const show = !info.isPending && !!info.data && info.data.secret.key && info.data.auth.authorised && !!info.data.auth.user?.permissions

    return (
        <Box sx={SX.box}>
            <Box component={"header"}>
                <Header
                    username={info.data?.auth.user?.username ?? "UNKNOWN"}
                    company={info.data?.config.company ?? "VEEGRES"}
                    show={!props.children && show}
                    showLogout={(info.data?.auth.supported.length ?? 0) > 0}
                />
            </Box>
            <Box component={"main"} sx={SX.body}>
                {props.children ? props.children : <Body info={info}/>}
            </Box>
            <Box component={"footer"}>
                <Footer
                    label={info.data?.version.label ?? "none"}
                    tag={info.data?.version.tag ?? "master"}
                />
            </Box>
        </Box>
    )
}
